import {useEffect, useState} from 'react'
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogActions,
  Typography,
  Button,
} from '@material-ui/core'
import RichText from '../RichText'

export default function MakeReminderEmail (props) {
  const [emailBody, setEmailBody] = useState('')

  const onClose = () => {
    props.onClose()
  }
  const onAdd = () => {
    props.onClose({success: true, emailBody})
  }

  useEffect(() => {
    if (props.emailBody) {
      setEmailBody(props.emailBody)
    }
  }, [])

  return (
    <Dialog open={props.open} maxWidth={'xl'} aria-labelledby="Custom Reminder email">
      <DialogTitle>Customize your reminder email for surveys</DialogTitle>
      <DialogContent style={{minHeight: 300}}>
        <DialogContentText>
            {'Create a custom reminder email for Participants, these are scheduled to go out when Participants do not complete their surveys on time.'}
        </DialogContentText>

        <Typography>Email Body</Typography>
        <RichText className="richSurveyEmailEditor" body={emailBody} onChange={(newBody) => setEmailBody(newBody)} />

      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">Close</Button>
        <Button onClick={onAdd} color="primary">Save</Button>
      </DialogActions>
    </Dialog>
  )
}
